import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { SharedContactInfo } from "@/types/api";

export const contactInfoApi = createApi({
  reducerPath: 'contactInfoApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/contact-info' }),
  tagTypes: ['ContactInfo'],
  endpoints: (builder) => ({
    getContactInfoWithToken: builder.query<SharedContactInfo, string>({
      query: (id) => {
        return {
          url: `/${id}`,
          method: "GET",
        }
      },
      providesTags: ['ContactInfo']
    }),
  }),
});

export const { useGetContactInfoWithTokenQuery } = contactInfoApi;
export default contactInfoApi;
